import { sendSubscriptionPaymentClosedEvent } from '@wwe-portal/web/libs/analytics/subscription';
import {
  usePurchaseXsollaPayment,
  UsePurchaseXsollaPaymentParameter,
} from './usePurchaseXsollaPayment';
import { BaseSubscriptionPlan } from '@wwe-portal/entities/subscription.type';

export interface SubscriptionMutationVariables {
  currentPlan: BaseSubscriptionPlan | null;
  plan: BaseSubscriptionPlan;
  version: string;
  cancelledPlanId?: string;
}

export const useSubscriptionPayment = ({
  onWidgetClosed,
  ...props
}: UsePurchaseXsollaPaymentParameter<SubscriptionMutationVariables>) => {
  return usePurchaseXsollaPayment<SubscriptionMutationVariables>({
    ...props,
    onWidgetClosed: (data) => {
      if (data?.plan) sendSubscriptionPaymentClosedEvent(data?.plan);
      onWidgetClosed?.(data);
    },
  });
};
